module.exports = __webpack_public_path__ + "img/browser.d864ce32.png";